/**
 * globo-price-addon.js
 * ---------------------------------------------------------------------------
 * Makes the Globo Product Options "Body Imprint" add-on behave/look like a
 * native theme variant option. Three concerns, all scoped strictly to Globo:
 *
 *   1) PDP total (#total-price) includes the selected add-on.
 *   2) Cart drawer line + subtotal (re-rendered by Sami Wholesale) show the
 *      true Shopify cart totals, which include the add-on.
 *   3) Visual: the Globo dropdown is skinned to match the theme's native
 *      variant dropdowns (open panel, selected/hover states), the "Selections
 *      will add $X" note is hidden, and the fee is shown inside the field
 *      (e.g. "1-color direct body imprint +$2.00") like the native options.
 *
 * Strict no-op unless a Globo option widget is on the page (PDP) or the cart
 * contains a Globo add-on (drawer), so no non-Globo product is affected.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  /* ------------------------------ PDP total ------------------------------ */

  function qty() {
    var q = document.querySelector('.quantity-container input, input[name="quantity"], .how_many input');
    return q ? Math.max(parseInt(q.value, 10) || 1, 1) : 1;
  }

  function addonPerUnit() {
    var a = 0;
    document.querySelectorAll('input[name="properties[_gpo_addon_products]"]').forEach(function (inp) {
      try {
        (JSON.parse(inp.value || '[]') || []).forEach(function (x) {
          if (x && (x.t === 'price' || x.t == null)) a += (parseFloat(x.p) || 0) * (parseInt(x.q, 10) || 1);
        });
      } catch (e) {}
    });
    return a;
  }

  function baseUnit() {
    var holder = document.querySelector('.samita_holder');
    if (!holder) return null;
    var q = qty(), price = null;
    holder.querySelectorAll('tr').forEach(function (r) {
      var cells = Array.prototype.map.call(r.querySelectorAll('td,th'), function (c) { return c.textContent.trim(); });
      var range = cells.find(function (c) { return /\d+\s*-\s*\d+|\d+\s*\+/.test(c); });
      var pr = cells.find(function (c) { return /\$\s*\d/.test(c); });
      if (range && pr) {
        var nums = (range.match(/\d+/g) || []).map(Number);
        var lo = nums[0], hi = /\+/.test(range) ? Infinity : (nums[1] || lo);
        if (q >= lo && q <= hi) price = parseFloat(pr.replace(/[^0-9.]/g, ''));
      }
    });
    return price;
  }

  function recalcPDP() {
    var el = document.querySelector('#total-price');
    if (!el) return;
    var b = baseUnit();
    if (b == null) return;
    var desired = money(Math.round((b + addonPerUnit()) * qty() * 100));
    if (el.textContent.trim() !== desired) el.textContent = desired;
  }

  /* ------------------------- Globo visual polish ------------------------- */

  function injectStyle() {
    if (document.getElementById('cz-globo-skin')) return;
    var css =
      '.gpo-container .gpo-element .gpo-label{display:inline!important;font-family:"Fira Sans",sans-serif!important;font-weight:400!important;font-size:14px!important;color:#343434!important;margin:0!important;padding:0!important;}' +
      '.gpo-container .gpo-element .gpo-label .label-content::after{content:":";}' +
      '.gpo-container .gpo-label .addOn{display:none!important;}' +
      '.gpo-container .gpo-element .gpo-selected-values{display:inline!important;font-family:"Fira Sans",sans-serif!important;font-weight:700!important;font-size:14px!important;color:#343434!important;margin:0 0 0 4px!important;}' +
      '.gpo-container .gpo-element .gpo-dropdown{width:fit-content!important;max-width:360px!important;margin-top:6px!important;min-width:290px!important;}' +
      '.gpo-container .gpo-dropdown .dropdown-button{border:1px solid #dfdfdf!important;border-radius:30px!important;padding:10px 16px!important;min-height:43px!important;background:#fff!important;width:auto!important;min-width:290px!important;font-family:"Fira Sans",sans-serif!important;font-size:14px!important;color:#343434!important;}' +
      /* collapsed panel: strip all chrome so nothing renders under the closed field */
      '.gpo-container .gpo-dropdown:not(.expanded) .dropdown-list{border:0!important;box-shadow:none!important;background:transparent!important;padding:0!important;margin:0!important;}' +
      /* open panel + items (only while expanded) */
      '.gpo-container .gpo-dropdown.expanded .dropdown-list{background:#fff!important;border:1px solid #dfdfdf!important;border-radius:14px!important;padding:6px!important;box-shadow:0 8px 22px rgba(0,0,0,.10)!important;min-width:290px!important;}' +
      '.gpo-container .dropdown-item{padding:0!important;background:transparent!important;border:0!important;}' +
      '.gpo-container .dropdown-item>label{display:flex!important;justify-content:space-between!important;align-items:center!important;gap:10px!important;white-space:nowrap!important;font-family:"Fira Sans",sans-serif!important;font-size:14px!important;font-weight:400!important;background:#f7f7f7!important;border-radius:12px!important;padding:12px 16px!important;margin:4px 0!important;cursor:pointer!important;}' +
      '.gpo-container .dropdown-item>label,.gpo-container .dropdown-item>label *{color:#343434!important;}' +
      '.gpo-container .dropdown-item:hover>label{background:#ededed!important;}' +
      '.gpo-container .dropdown-list .dropdown-item input:checked+label{background:#efeae7!important;font-weight:600!important;}' +
      '.gpo-container .dropdown-item svg,.gpo-container .dropdown-item svg *,.gpo-container .dropdown-item [class*="check"]{color:#343434!important;fill:#343434!important;stroke:#343434!important;}' +
      /* hide the "Selections will add $X" note */
      '.gpo-container .gpo-total{display:none!important;}';
    var s = document.createElement('style');
    s.id = 'cz-globo-skin';
    s.textContent = css;
    document.head.appendChild(s);
  }

  // Show the fee inside the option label / field as " +$X.XX" (like native
  // "...+$1.75") instead of Globo's "(+ $X)", in the list, the selected field
  // and the header summary.
  function formatGloboLabels() {
    var gc = document.querySelector('.gpo-container');
    if (!gc) return;
    gc.querySelectorAll('.dropdown-item > label').forEach(function (l) {
      var t = l.textContent.replace(/\s+/g, ' ').trim();
      var m = t.match(/\(\+\s*\$?\s*([\d.,]+)\)|\+\s*\$?\s*([\d.,]+)/);
      var base = t.replace(/\s*\(\+[^)]*\)\s*/, '').replace(/\s*\+\s*\$?\s*[\d.,]+\s*$/, '').trim();
      var want = m ? (base + ' +$' + parseFloat((m[1] || m[2]).replace(/,/g, '')).toFixed(2)) : base;
      if (l.textContent.trim() !== want) l.textContent = want;
    });
    var chk = gc.querySelector('.dropdown-item input:checked');
    if (chk) {
      var lab = chk.closest('.dropdown-item').querySelector('label');
      var disp = lab ? lab.textContent.trim() : '';
      var sv = gc.querySelector('.gpo-selected-values');
      if (sv && sv.textContent.trim() !== disp) sv.textContent = disp;
      var bv = gc.querySelector('.dropdown-button__value');
      if (bv && bv.textContent.trim() !== disp) bv.textContent = disp;
    }
  }

  function onGpo() { recalcPDP(); formatGloboLabels(); }

  function attachPDP() {
    if (!document.querySelector('.gpo-container')) return; // only on Globo products
    injectStyle();
    var el = document.querySelector('#total-price');
    if (el && !el.__czObserved) {
      el.__czObserved = true;
      new MutationObserver(recalcPDP).observe(el, { childList: true, characterData: true, subtree: true });
    }
    var gpo = document.querySelector('.gpo-container');
    if (gpo && !gpo.__czObserved) {
      gpo.__czObserved = true;
      new MutationObserver(onGpo).observe(gpo, { childList: true, characterData: true, subtree: true, attributes: true });
    }
    onGpo();
  }

  /* --------------------- Cart drawer (Sami display) ---------------------- */

  var scheduled = false;
  function scheduleCartFix() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; fixCartDrawer(); }, 150);
  }

  function fixCartDrawer() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .wt-cart__drawer');
    if (!drawer) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.items || !c.items.some(function (i) { return i.properties && i.properties['_gpo_addon_products']; })) return;
        drawer.querySelectorAll('li.cart-item[id^="CartDrawer-Item-"]').forEach(function (li) {
          var m = li.id.match(/CartDrawer-Item-(\d+)/);
          if (!m) return;
          var item = c.items[parseInt(m[1], 10) - 1];
          if (!item) return;
          var correct = money(item.final_line_price);
          li.querySelectorAll('.samitaWS-customized-price, .samitaWS-customized-original-price').forEach(function (n) {
            if (n.textContent.trim() !== correct) n.textContent = correct;
          });
        });
        var total = money(c.total_price);
        drawer.querySelectorAll('.samitaWS-customized-price, .samitaWS-customized-original-price').forEach(function (n) {
          if (!n.closest('li.cart-item') && n.textContent.trim() !== total) n.textContent = total;
        });
      })
      .catch(function () {});
  }

  function attachCart() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .wt-cart__drawer');
    if (drawer && !drawer.__czObserved) {
      drawer.__czObserved = true;
      new MutationObserver(scheduleCartFix).observe(drawer, { childList: true, subtree: true, characterData: true });
    }
    scheduleCartFix();
  }

  /* ------------------------------- boot ---------------------------------- */

  function boot() {
    attachCart();
    if (document.querySelector('.gpo-container')) {
      attachPDP();
    } else {
      var tries = 0;
      var timer = setInterval(function () {
        if (document.querySelector('.gpo-container')) { clearInterval(timer); attachPDP(); }
        else if (++tries > 20) { clearInterval(timer); }
      }, 300);
    }
  }

  if (!window.__czGloboAddonInit) {
    window.__czGloboAddonInit = true;
    document.addEventListener('input', function (e) {
      if (e.target.closest && e.target.closest('.quantity-container, .how_many')) recalcPDP();
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.quantity-container, .how_many, .gpo-container')) onGpo();
    }, true);
    document.addEventListener('shopify:section:load', boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
